import { Product } from 'utils/helpers/product';
import { ProductsProvider } from 'src/gql/graphql';

export enum Scenarios {
  cart1 = `cart1`,
  productDetailsPage1 = `pdp1`,
  productDetailsPage2 = `pdp2`,
}

type ProductsFilter = Partial<{
  productIds: string[];
  types: string[];
  sortBy: string;
}>;

type ProductsVariables = {
  perPage: number;
  productsFilter: ProductsFilter & {
    bypassOnlineThresholds: boolean;
    dispensaryId: string;
    isKioskMenu: boolean;
    pricingType: string;

    Status: 'Active';
  };
};

type GetProducts = (variables: ProductsVariables, productsProvider?: ProductsProvider) => Promise<Product[]>;

type GetProductsFallback = (productsFilter: ProductsFilter) => ReturnType<GetProducts>;

export type GetRecommendationsFallback = (getProducts: GetProductsFallback) => ReturnType<GetProductsFallback>;

export type Options = Partial<{
  skip: boolean;
  limit: number;
  excludeProducts?: string[];
}>;
